import { Button, Typography } from "@suraasa/placebo-ui"
import { AIToolsTabs } from "features/AItools"
import { ArrowRight } from "iconoir-react"
import { TooltipRenderProps } from "react-joyride"

import { AI_TOOLS_ONBOARDING_TARGETS } from "./types"

const OnboardingStep = ({
  toolTipRenderProps,
  switchTabsFunc,
  navigateFunc,
  onComplete,
}: {
  toolTipRenderProps: TooltipRenderProps
  switchTabsFunc: (tab: AIToolsTabs) => void
  navigateFunc: () => void
  onComplete: () => void
}) => {
  const { index, primaryProps, step, isLastStep, size } = toolTipRenderProps
  const handleNext = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (
      step.target.toString().includes(AI_TOOLS_ONBOARDING_TARGETS.exploreTools)
    ) {
      switchTabsFunc(AIToolsTabs.history)
    }
    if (
      step.target.toString().includes(AI_TOOLS_ONBOARDING_TARGETS.accessHistory)
    ) {
      switchTabsFunc(AIToolsTabs.tools)
    }
    if (
      step.target.toString().includes(AI_TOOLS_ONBOARDING_TARGETS.takeALook)
    ) {
      navigateFunc()
    }
    if (isLastStep) {
      onComplete()
    }

    primaryProps.onClick(e)
  }
  const label = () => {
    if (
      step.target.toString().includes(AI_TOOLS_ONBOARDING_TARGETS.takeALook)
    ) {
      return "Continue"
    }
    return isLastStep ? "Finish Tour" : "Next"
  }
  return (
    <div className="flex min-h-[168px] w-full max-w-[calc(100vw_-_32px)] flex-col justify-between overflow-hidden rounded-xl bg-white p-2.5 sm:w-[345px] sm:max-w-none">
      <div>{step.content}</div>
      <div className="flex w-full items-center justify-between">
        <Typography variant="preTitle" className="text-onSurface-500">
          {index + 1} OF {size}
        </Typography>
        <div className="flex items-center gap-2">
          <Button
            size="sm"
            color="black"
            endAdornment={!isLastStep ? <ArrowRight /> : undefined}
            onClick={handleNext}
          >
            {label()}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default OnboardingStep
